module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_10.299fcf2f.jpg";